import gql from 'graphql-tag'
import API from '@/api/apiHelper'

export default {
  tickets() {
    return {
      query: gql`
        query Query($search: String, $status: [String]) {
          ticketSearch(search: $search, status: $status) {
            data {
              id
              name
              parent
              ticket_parent {
                ... on ServiceLocation {
                  name(short: true)
                }
                ... on Site {
                  name
                }
                ... on Service {
                  name
                }
              }
              customer_ticket_id
              status
              state
              created_at
              service_id
              workflow {
                id
                name
              }
            }
          }
        }
      `,
      result({ data }) {
        const tickets = data?.ticketSearch?.data || []
        this.$store.commit('set', ['sidebarRecords', tickets])
      },
      skip() {
        return !this.sidebarTags.length
      },
      variables() {
        return {
          search: this.sidebarSearch,
          status: this.sidebarTags
        }
      }
    }
  },

  ticket(ticketId) {
    return API.query(
      `
      query Query($ticketId: ID) {
        ticket(id: $ticketId) {
          ticket_data
          id
          name
          customer_ticket_id
          status
          substatus
          classification
          severity
          ticket_privacy
          is_cf_ticket
          assigned_team
          assigned
          sla_time
          recovery_estimate
          initial_description
          ticket_resolution
          additional_email
          created_at
          updated_at
          investigation_status
          responses {
            response_body
            id
            after_hours_billable
            time_spent
            response_type
            system_response
            creator {
              id
              first_name
              last_name
              full_name
              admin
            }
            attachment {
              id
              file_name
            }
            ticket_has_file_attachment
            created_at
          }
          creator {
            username
          }
          workflow_fields
          ticket_parent {
            ... on ServiceLocation {
              name
            }
            ... on Site {
              name
            }
            ... on Service {
              name
            }
          }
        }
      }
      `,
      {
        ticketId: ticketId
      },
      {
        transformation(data) {
          data.workflow_fields = JSON.parse(data.workflow_fields)
          data.ticket_data = JSON.parse(data.ticket_data)
          return data
        }
      }
    )
  },

  workflowReasons() {
    return gql`
      query Query {
        workflows {
          id
          name
          reasons
          classification
        }
      }
    `
  },

  workflowCreator() {
    return gql`
      query WorkFlow($id: ID) {
        workflow(id: $id) {
          id
          name
          creator
        }
      }
    `
  },

  ticketWizard() {
    return gql`
      query Ticket($id: ID) {
        ticket(id: $id) {
          id
          ticket_data
          wizard_fields
          active_workflow_step
        }
      }
    `
  }
}
